/** Live snapshots carry host catalogue IDs, which can differ from the web catalogue. */
export function resolveLiveReference<T extends { id: number }>(
  id: number,
  current: T | null | undefined,
  snapshotReferences: Array<T | null | undefined>,
  catalogue: T[],
): T {
  const reference =
    current?.id === id
      ? current
      : (snapshotReferences.find((row) => row?.id === id) ??
        catalogue.find((row) => row.id === id));
  if (!reference) throw new Error("LIVE_REFERENCE_UNAVAILABLE");
  return reference;
}
